(function ($) {
  'use strict';

  /**
   * Tiny bits of JS magic
   */
  function Snippets () { }

  Snippets.prototype = {

    /*
     * Start with init Function
     */
    init: function () {
      this.initFitVids();
      this.initSVGFallback();
      this.initSortingControls();
      this.initFilterControls();
      this.initHelpText();
      this.initNotesField();
      this.initNaCheckboxes();
      this.initSaveRepaymentOffers();
      this.initAccordionNav();
      this.initUserModuleInstanceSubmission();
      this.initClientInvitationTypeSwitch();
      this.initStacktable();
      this.initReportDateFieldsToggle();
      this.initLogoutButton();
      this.showNetworkSelect();
    },

    initLogoutButton: function () {
      $('.js-trigger-logout').on('click', function (e) {
        e.preventDefault();
        var $logoutForm = $('.js-logout-form');
        $logoutForm.submit();
      });
    },

    // FitVids for responsive videos
    initFitVids: function () {
      $('.js-fitvids').fitVids();
    },

    // PNG fallback for img elements with SVG src
    initSVGFallback: function () {
      if (!window.Modernizr.svgasimg) {
        $('img[src$=".svg"]').each(function () {
          var src = $(this).attr('src');
          var fallback = src.replace(/svg/g, 'png');
          $(this).attr('src', fallback);
        });
      }
    },

    // Sorting controls
    initSortingControls: function () {
      this.$orderSelect = $('.js-entry-order');

      if (this.$orderSelect.length < 1) { return; }

      this.$orderSelect.on('change', $.proxy(this.onOrderSelect, this));
    },

    onOrderSelect: function (e) {
      this.$sortingForm = $('.js-sorting-form');

      if (this.$sortingForm.length < 1) { return; }

      this.$sortingForm.submit();
    },

    initFilterControls: function () {
      this.$filterSelect = $('.js-filter-select');

      if (this.$filterSelect.length < 1) { return; }

      this.$filterSelect.on('change', $.proxy(this.onFilterSelect, this));
    },

    onFilterSelect: function (e) {
      this.$filteringForm = $('.js-filtering-form');

      if (this.$filteringForm.length < 1) { return; }

      this.$filteringForm.submit();
    },

    initHelpText: function () {
      this.$helpTextToggles = $('.js-help-text-toggle');

      if (this.$helpTextToggles.length < 1) { return; }

      this.$helpTextToggles.on('click', $.proxy(this.onHelpTextToggle, this));
    },

    onHelpTextToggle: function (e) {
      let $helpTextContent = $(e.target).siblings('.js-help-text-content');

      $(e.target).attr('aria-expanded', function (i, attr) {
        return attr === 'true' ? 'false' : 'true';
      });

      $(e.target).toggleClass('expanded');

      $helpTextContent.toggleClass('u-js-hide');
    },

    initNotesField: function () {
      this.$helpTextToggles = $('.js-notes-toggle');

      if (this.$helpTextToggles.length < 1) { return; }

      this.$helpTextToggles.on('click', $.proxy(this.onNotesFieldClick, this));
    },

    onNotesFieldClick: function (e) {
      let $showNotesButton = $(e.target);
      let $notesField = $(e.target).siblings('.js-notes-field');
      let $notesTextarea = $notesField.find('textarea');
      let $notesCheckboxLabel = $notesField.find('label');
      let $notesCheckbox = $notesField.find('.js-hide-notes-checkbox');

      if ($notesField.hasClass('u-js-hide')) {
        $notesField.removeClass('u-js-hide');
        $showNotesButton.text('Remove note');
      } else {
        $notesField.addClass('u-js-hide');
        $showNotesButton.text('Add note');
        $notesTextarea.val('');
        $notesCheckboxLabel.removeClass('selected');
        $notesCheckbox.prop('checked', false);
      }
    },

    initNaCheckboxes: function () {
      this.$naCheckboxes = $('.js-na-checkbox');

      if (this.$naCheckboxes.length < 1) { return; }

      // Initialise value on load
      this.$naCheckboxes.map((i, el) => {
        this.setFieldDisabledAttribute(el);
      });

      this.$naCheckboxes.on('click', $.proxy(this.onNaCheckboxClick, this));
    },

    onNaCheckboxClick: function (e) {
      let naCheckbox = e.target;

      this.setFieldDisabledAttribute(naCheckbox, true);
    },

    setFieldDisabledAttribute (naCheckbox, enable = false) {
      // Split Id on '.' to get base field id
      let fieldId = $(naCheckbox).attr('id').split('.')[0];
      // then get all other inputs/selects/textareas (apart from notes and this N/A checkbox)
      let $otherFields = $(`input[id^="${fieldId}."], select[id^="${fieldId}."], textarea[id^="${fieldId}."]`).not(`[id="${fieldId}.na"]`);

      let $notesContainer = $(`div[id^="${fieldId}.notes-container"]`);
      let $notesField = $notesContainer.find('.js-notes-field');

      // Add/remove disabled attribute
      if ($(naCheckbox).is(':checked')) {
        $otherFields.prop('disabled', true);
        $notesField.addClass('disabled');
      } else if (enable) {
        // We shouldn't need to remove disabled here
        $otherFields.prop('disabled', false);
        $notesField.removeClass('disabled');
      }
    },

    initAccordionNav () {
      $('.js-accordion').accordion();

      // Add 'here' class to accordion button
      $('[data-accordion-opened="true"]').prev('.js-accordion__header').addClass('here');
      $('.complete').prev('.js-accordion__header').addClass('complete');
    },

    initSaveRepaymentOffers () {
      $('.js-repayment-offer').on('keyup', $.proxy(this.showSaveRepaymentOffer, this));
    },

    showSaveRepaymentOffer (e) {
      let repaymentOfferInput = e.target;
      let elementIndex = $(repaymentOfferInput).data('repetitionIndex');
      $('.js-debt-repayment-offer-save[data-repetition-index="' + elementIndex + '"]').removeClass('u-visibility-hidden');
    },

    initUserModuleInstanceSubmission () {
      $('.js-umi-submit').on('click', $.proxy(this.showUserModuleInstanceSubmissionConfirmation, this));
      $('.js-umi-submit-hide').on('click', $.proxy(this.hideUserModuleInstanceSubmissionConfirmation, this));
    },

    showUserModuleInstanceSubmissionConfirmation (e) {
      e.preventDefault();
      $('.js-umi-submission-confirm').toggleClass('u-js-hide');
    },

    hideUserModuleInstanceSubmissionConfirmation (e) {
      e.preventDefault();
      $('.js-umi-submission-confirm').toggleClass('u-js-hide');
    },

    initClientInvitationTypeSwitch: function () {
      let $managementTypeRadios = $('input[name=management_type]');

      if ($managementTypeRadios.length > 0) {
        $managementTypeRadios.on('click', $.proxy(this.showHideEmailField, this));
      }
    },

    showHideEmailField (e) {
      let $theTarget = $(e.target);
      let $theFieldset = $('#emailFieldSet');
      let $theInput = $('input[name=email]');
      let $theWarning = $('#invitationWarning');

      if ($theTarget.attr('value') === 'agency_managed') {
        $theFieldset.hide();
        $theInput.prop('disabled', true);
        $theInput.removeAttr('required');
        $theWarning.show();
      } else {
        $theFieldset.show();
        $theInput.prop('disabled', false);
        $theInput.prop('required', true);
        $theWarning.hide();
      }
    },

    initStacktable () {
      $('.js-stack-table').stacktable();
    },

    initReportDateFieldsToggle () {
      let $reportTypeSelect = $('select[name=report]');
      if ($reportTypeSelect.length > 0) {
        $reportTypeSelect.trigger('change');
        $reportTypeSelect.on('change', $.proxy(this.toggleReportDateFieldset, this));
      }
    },

    toggleReportDateFieldset (e) {
      let $theTarget = $(e.target);
      let $theFieldset = $('.js-report-date');

      if ($theTarget.val() === 'creditorUsers') {
        $theFieldset.hide();
        $theFieldset.find('input, select, textarea').prop('disabled', true);
      } else {
        $theFieldset.show();
        $theFieldset.find('input, select, textarea').prop('disabled', false);
      }
    },

    showNetworkSelect () {
      let $roleSelect = $('.js-role-select');
      let $networkField = $('.js-network-field');
      $networkField.hide();
      $networkField.prop('disabled', true);
      if ($roleSelect.find('option:selected').text() == 'Family Care Co-ordinator') {
        $networkField.show();
        $networkField.prop('disabled', false);
      }

      $roleSelect.on('change', function () {
        if ($roleSelect.find('option:selected').text() == 'Family Care Co-ordinator'){
          $networkField.show();
          $networkField.prop('disabled', false);
        } else {
          $networkField.hide();
          $networkField.prop('disabled', true);
        }
      });
    },
  };

  

  this.Snippets = Snippets;
}).call(Framework, jQuery);
